import React, { useContext, useEffect } from "react";
import "../../../Menu.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useTranslation } from "react-i18next";
import { Notifications } from "../../../Context/Notifications";

const NotificationMenuComponent = ({
  handleCloseNotificationMenu,
  notifications,
  handleToggleNotifications,
  renderMobileVersion,
}) => {
  const { t } = useTranslation();

  const { deleteNotification, readNotification, reloadNotifications } = useContext(Notifications);
  const unreadNotificationsCount = notifications?.filter((alert) => alert.isNew).length || 0;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDeleteNotifications = (id) => {
    deleteNotification(id);
    setTimeout(() => {
      reloadNotifications();
    }, 250);
  };

  const handleReadNotifications = (alert) => {
    if (!!alert.isNew) {
      readNotification(alert.id);
      setTimeout(() => {
        reloadNotifications();
      }, 250);
    }
  };

  return (
    <div className={"MenuLateralResContainer"} onClick={handleCloseNotificationMenu}>
      <div className={"NotificationMenuRes"}>
        {/* Contenedor centrado */}
        <div className="NotificationTitleContainer">
          <p className="NotificationMenuTitle">
            {t("notifications")}{" "}
            {unreadNotificationsCount > 0 && (
              <span className="UnreadCount">({unreadNotificationsCount})</span>
            )}
          </p>
        </div>
  
        <div className={"AlertContainer"}>
          {notifications && notifications.length > 0 ? (
            notifications.map((alert) => (
              <div
                key={alert.id}
                className={!!alert.isNew ? "AlertCard NewCard" : "AlertCard"}
                onClick={() => handleReadNotifications(alert)}
              >
                {alert.img && <img src={alert.img} className={"AlertImage"} alt={alert.title} />}
                <div className={"AlertTextContainer"}>
                  <p className={"AlertTitle"}>{alert.title}</p>
                  <p className={"AlertText"}>{alert.description}</p>
                </div>
                <div className={"deleteIconMessage"}>
                  <OverlayTrigger
                    delay={{ hide: 450, show: 300 }}
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-delete-${alert.id}`}>
                        {t("notification.deleteTooltip")}
                      </Tooltip>
                    }
                  >
                    <button
                      type="button"
                      className="DeleteNotificationButton"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteNotifications(alert.id);
                      }}
                      aria-label={t("notification.delete")}
                    >
                      <ion-icon name="trash-outline" aria-hidden="true" />
                    </button>
                  </OverlayTrigger>
                </div>
              </div>
            ))
          ) : (
            <p className="NoNotificationsMessage">{t("notification.noNotifications")}</p>
          )}
        </div>
      </div>
    </div>
  );
  
};

export default NotificationMenuComponent;
